import React, { useState, useEffect, useRef } from 'react';
import './CourtBulkBooking.css';
import { Link } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { useNavigate, useLocation } from 'react-router-dom';
import { fireAudit } from '../utils/auditClient';

const CourtBulkBooking = () => {
  const { selectedCenter } = useUser();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    court: [],
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
    weekdays: [],
    mobile: '',
    name: '',
    remark: '',
    bookingType: null,
    pricePerHour: ''
  });
  const token = localStorage.getItem('auth-token');
  const [conflictingBookings, setConflictingBookings] = useState([]);
  const [showConflictModal, setShowConflictModal] = useState(false);
  const [proceedAnyway, setProceedAnyway] = useState(false);
  const baselineRef = useRef(null);

  useEffect(() => {
    if (formData.mobile.length === 10) {
      const formattedMobileNumber = `+91${formData.mobile}`;
      const apiUrl = `${process.env.REACT_APP_API_PLAYER_SEARCH}?academyId=${selectedCenter}&mobileNumber=${formData.mobile}`;
      const fetchUser = async () => {
        try {
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          };
          const response = await fetch(apiUrl, {
            method: 'GET',
            headers: headers,
          });
          const data = await response.json();
          if (data && data.data && data.data.searchData) {
            const user = data.data.searchData.find(item => item.mobile_number === formattedMobileNumber);
            if (user) {
              setFormData(prevState => ({
                ...prevState,
                name: user.name || ''
              }));
            } else {
              setFormData(prevState => ({
                ...prevState,
                name: ''
              }));
            }
          } else {
            setFormData(prevState => ({
              ...prevState,
              name: ''
            }));
          }
        } catch (error) {
          setFormData(prevState => ({
            ...prevState,
            name: ''
          }));
        }
      };
      fetchUser();
    }
  }, [formData.mobile, selectedCenter]);

  const [bookingTypeOptions, setBookingTypeOptions] = useState([]);
  const handleBookingTypeChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      bookingType: selectedOption,
    }));
  };
  const [courtList, setCourtList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateTimeOptions = () => {
    const times = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const time = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
        times.push({ value: time, label: time });
      }
    }
    return times;
  };

  const timeOptions = generateTimeOptions();
  const getEndTimeOptions = () => {
    if (!formData.startTime) return timeOptions;
    return timeOptions.filter((option) => option.value > formData.startTime);
  };

  const getEndDateOptions = () => {
    if (!formData.startDate) return '';
    return formData.startDate;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (name === 'startTime') {
      setFormData((prev) => ({ ...prev, endTime: '' }));
    }
    if (name === 'startDate') {
      setFormData((prev) => ({ ...prev, endDate: '' }));
    }
  };

  const handleCourtChange = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      court: selectedOptions,
    }));
  };

  const handleWeekdaysChange = (selectedOptions) => {
    setFormData({ ...formData, weekdays: selectedOptions });
  };

  const handleTimeChange = (selectedOption, field) => {
    setFormData({ ...formData, [field]: selectedOption.value });
  };

  const buildAuditPayload = (confirmFlag) => {
    const formatDateTime = (date, time) => {
      if (!date || !time) return '';
      const [hours, minutes] = time.split(':');
      const localDate = new Date(date);
      localDate.setUTCHours(hours, minutes, 0, 0);
      return localDate.toISOString();
    };
    return {
      academyId: Number(selectedCenter),
      courtIds: formData.court.map((c) => Number(c.value)),
      startDate: formData.startDate,
      endDate: formData.endDate,
      startTime: formatDateTime(formData.startDate, formData.startTime),
      endTime: formatDateTime(formData.endDate, formData.endTime),
      weekdays: formData.weekdays,
      username: formData.name || 'No Name',
      userMobileNumber: formData.mobile,
      remark: formData.remark || 'No remarks',
      bookingFor: formData.bookingType?.value || 'Coupon',
      isConfirm: !!confirmFlag,
      pricePerHour: formData.pricePerHour ? Number(formData.pricePerHour) : 0,
    };
  };

  useEffect(() => {
    baselineRef.current = buildAuditPayload(false);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.weekdays.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select at least one weekday.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }
    if (formData.mobile && formData.mobile.length !== 10) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please enter a 10-digit mobile number.",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }
    const formatDateTime = (date, time) => {
      const [hours, minutes] = time.split(":");
      const localDate = new Date(date);
      localDate.setUTCHours(hours, minutes, 0, 0);
      return localDate.toISOString();
    };
    const payload = {
      academyId: Number(selectedCenter),
      courtIds: formData.court.map((court) => Number(court.value)),
      startDate: formData.startDate,
      endDate: formData.endDate,
      startTime: formatDateTime(formData.startDate, formData.startTime),
      endTime: formatDateTime(formData.endDate, formData.endTime),
      weekdays: formData.weekdays,
      username: formData.name || "No Name",
      userMobileNumber: formData.mobile,
      remark: formData.remark || "No remarks",
      bookingFor: formData.bookingType?.value || "Coupon",
      isConfirm: false,
      pricePerHour: formData.pricePerHour ? Number(formData.pricePerHour) : 0,
    };
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BULK_COURT_BOOKING}?academyId=${selectedCenter}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();
      if (response.ok && result.success) {
        const newPayload = buildAuditPayload(false);
        const oldPayload = baselineRef.current || {};
        const affected_id = result?.data?.id ?? `${selectedCenter}-${formData.mobile}-${newPayload.startTime}-${newPayload.endTime}`;
        fireAudit({
          entity: 'court_bulk_booking',
          affected_id,
          action: 'create',
          section: 'Court Booking',
          subSection: 'Court Bulk Booking',
          businessApi: `${process.env.REACT_APP_API_BULK_COURT_BOOKING}?academyId=${selectedCenter}`,
          businessMethod: 'POST',
          oldPayload,
          newPayload,
          extra: { proceedAnyway: false },
        });
        baselineRef.current = newPayload;
        navigate("/bulkbookinglist");
        setTimeout(() => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Booking submitted successfully",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }, 100);
      } else {
        if (result.data?.bookings) {
          setConflictingBookings(result.data.bookings);
          setShowConflictModal(true);
        } else {
          const errorMsg = result?.data?.errorMessage || "Something went wrong!";
          throw new Error(errorMsg);
        }
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };

  const handleProceedAnyway = async () => {
    setProceedAnyway(true);
    setShowConflictModal(false);
    const formatDateTime = (date, time) => {
      const [hours, minutes] = time.split(":");
      const localDate = new Date(date);
      localDate.setUTCHours(hours, minutes, 0, 0);
      return localDate.toISOString();
    };
    const payload = {
      academyId: Number(selectedCenter),
      courtIds: formData.court.map((court) => Number(court.value)),
      startDate: formData.startDate,
      endDate: formData.endDate,
      startTime: formatDateTime(formData.startDate, formData.startTime),
      endTime: formatDateTime(formData.endDate, formData.endTime),
      weekdays: formData.weekdays,
      username: formData.name || "No Name",
      userMobileNumber: formData.mobile,
      remark: formData.remark || "No remarks",
      bookingFor: formData.bookingType?.value || "Coupon",
      isConfirm: true,
      pricePerHour: formData.pricePerHour ? Number(formData.pricePerHour) : 0,
    };
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BULK_COURT_BOOKING}?academyId=${selectedCenter}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();
      if (response.ok && result.success) {
        const newPayload = buildAuditPayload(true);
        const oldPayload = baselineRef.current || {};
        const affected_id = result?.data?.id ?? `${selectedCenter}-${formData.mobile}-${newPayload.startTime}-${newPayload.endTime}`;
        fireAudit({
          entity: 'court_bulk_booking',
          affected_id,
          action: 'create',
          section: 'Court Booking',
          subSection: 'CourtBulkBooking',
          businessApi: `${process.env.REACT_APP_API_BULK_COURT_BOOKING}?academyId=${selectedCenter}`,
          businessMethod: 'POST',
          oldPayload,
          newPayload,
          extra: { proceedAnyway: true },
        });
        baselineRef.current = newPayload;
        navigate("/bulkbookinglist");
        setTimeout(() => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Booking submitted successfully",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        }, 100);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong while submitting the booking.",
      });
    }
  };

  useEffect(() => {
    if (selectedCenter) {
      const fetchData = async () => {
        setLoading(true);
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_BULK_COURT_BOOKING}?academyId=${selectedCenter}`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
              },
            }
          );
          const data = await response.json();
          if (data.success) {
            setCourtList(data.data.courtList);
            const newBookingTypeOptions = data.data.bookingFor.map(item => ({
              value: item.key,
              label: item.label,
            }));
            setBookingTypeOptions(newBookingTypeOptions);
          } else {
            setError('Failed to fetch court data.');
          }
        } catch (error) {
          setError('Error fetching data.');
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }
  }, [selectedCenter]);

  const courtOptions = courtList.map((court) => ({
    value: court.id,
    label: court.name,
  }));

  useEffect(() => {
    if (formData.startDate && formData.endDate) {
      const startDate = new Date(formData.startDate);
      const endDate = new Date(formData.endDate);
      if (endDate < startDate) {
        return;
      }
      const daysInRange = [];
      const currentDate = new Date(startDate);
      while (currentDate <= endDate) {
        const dayName = currentDate.toLocaleDateString('en-US', { weekday: 'long' });
        if (!daysInRange.includes(dayName)) {
          daysInRange.push(dayName);
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }
      setFormData(prev => ({
        ...prev,
        weekdays: daysInRange
      }));
    }
  }, [formData.startDate, formData.endDate]);

  const ConflictModal = () => {
    const handleOverlayClick = (e) => {
      if (e.target.classList.contains('conflict-modal-overlay')) {
        setShowConflictModal(false);
      }
    };
    return (
      <div className="conflict-modal-overlay" onClick={handleOverlayClick}>
        <div className="conflict-modal" onClick={(e) => e.stopPropagation()}>
          <h3>Booking Conflicts Detected</h3>
          <p style={{margin:0,padding:0}}>The following slots are already booked:</p>
          <div className="conflict-list">
            {conflictingBookings.map((booking, index) => (
              <div key={index} className="conflict-item">
                <p><strong>Court:</strong> {booking.courtName}</p>
                <p><strong>Date:</strong> {new Date(booking.date).toLocaleDateString()}</p>
                <p><strong>Time:</strong> {booking.displayTime}</p>
                <p><strong>Booked by:</strong> {booking.username} ({booking.mobile})</p>
              </div>
            ))}
          </div>
          <div className="modal-actions">
            <button
              className="cancel-btn"
              onClick={() => setShowConflictModal(false)}
            >
              Cancel
            </button>
            <button
              className="proceed-btn"
              onClick={handleProceedAnyway}
            >
              Book Available slots
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="enrollment-container">
      <div className="breadcrumb">
        <Link to="/" className="breadcrumb-link">Dashboard</Link> &gt; Bulk Booking
      </div>

      {loading && <p>Loading court list...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <form className="walkin-enquiry-form" onSubmit={handleSubmit}>
        <div className="floating-select-form" style={{ width: '100%' }}>
          <Select
            id="court"
            name="court"
            options={courtOptions}
            value={formData.court}
            onChange={handleCourtChange}
            isMulti
            required
            closeMenuOnSelect={false}
            placeholder="Select Court"
            className={`walkin-form-dropdown ${formData.court && formData.court.length ? 'has-value' : ''}`}
            classNamePrefix="walkin-select"
            isClearable
            styles={{
              control: (provided) => ({
                ...provided,
                padding: '5px',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {formData.court && formData.court.length > 0 && <label htmlFor="court">Court</label>}
        </div>

        <div className="floating-select-form" style={{ width: '100%' }}>
          <Select
            id="bookingType"
            name="bookingType"
            options={bookingTypeOptions}
            value={formData.bookingType}
            onChange={handleBookingTypeChange}
            placeholder="Select Booking Type"
            className={`walkin-form-dropdown ${formData.bookingType ? 'has-value' : ''}`}
            classNamePrefix="walkin-select"
            isClearable
            required
            styles={{
              control: (provided) => ({
                ...provided,
                padding: '5px',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {formData.bookingType && <label htmlFor="bookingType">Booking For</label>}
        </div>

        {formData.bookingType?.value === "USER_BULK_BOOKING" && (
          <div className="form-field">
            <label htmlFor="pricePerHour">Price per Hour (₹):</label>
            <input
              type="number"
              id="pricePerHour"
              name="pricePerHour"
              className="input-field"
              value={formData.pricePerHour}
              onChange={handleChange}
              placeholder="Enter price per hour"
              min={0}
            />
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ fontWeight: 'bold', marginRight: '12px' }}>
                Effective per hour price =
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 'bold' }}>Amount paid by the user</div>
                <div
                  style={{
                    borderBottom: '2px solid black',
                    width: '200px',
                    margin: '4px 0px',
                  }}
                ></div>
                <div style={{ marginLeft: '4px', fontWeight: 'bold' }}>Total number of hours</div>
              </div>
            </div>
          </div>
        )}

        <div className="floating-select-form" >
          <input
            type="date"
            id="startDate"
            name="startDate"
            className="walkin-form date-picker-input has-value"
            value={formData.startDate}
            onChange={handleChange}
            required
            min={new Date().toISOString().split('T')[0]}
            onClick={(e) => e.target.showPicker()}
          />
          <label htmlFor="startDate">Start Date</label>
        </div>

        <div className="floating-select-form" >
          <input
            type="date"
            id="endDate"
            name="endDate"
            className="walkin-form date-picker-input has-value"
            value={formData.endDate}
            onChange={handleChange}
            required
            min={getEndDateOptions()}
            onClick={(e) => e.target.showPicker()}
          />
          <label htmlFor="endDate">End Date</label>
        </div>

        <div className="floating-select-form" style={{ width: '100%' }}>
          <Select
            id="startTime"
            name="startTime"
            options={timeOptions}
            value={timeOptions.find((option) => option.value === formData.startTime)}
            onChange={(selectedOption) => handleTimeChange(selectedOption, 'startTime')}
            placeholder="Select Start Time"
            className={`walkin-form-dropdown ${formData.startTime ? 'has-value' : ''}`}
            classNamePrefix="walkin-select"
            isClearable
            required
            styles={{
              control: (provided) => ({
                ...provided,
                padding: '5px',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {formData.startTime && <label htmlFor="startTime">Start Time</label>}
        </div>

        <div className="floating-select-form" style={{ width: '100%' }}>
          <Select
            id="endTime"
            name="endTime"
            options={getEndTimeOptions()}
            value={timeOptions.find((option) => option.value === formData.endTime)}
            onChange={(selectedOption) => handleTimeChange(selectedOption, 'endTime')}
            placeholder="Select End Time"
            className={`walkin-form-dropdown ${formData.endTime ? 'has-value' : ''}`}
            classNamePrefix="walkin-select"
            isClearable
            required
            styles={{
              control: (provided) => ({
                ...provided,
                padding: '5px',
              }),
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
            }}
          />
          {formData.endTime && <label htmlFor="endTime">End Time</label>}
        </div>

        <fieldset className="enrollment-form-fieldset" style={{marginTop:'0px'}}>
          <legend>Select Weekdays:</legend>
          <div className="weekdays-checkbox-container">
            {['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'].map((day) => (
              <label key={day} className="weekday-checkbox-label">
                <input
                  type="checkbox"
                  name="weekdays"
                  value={day}
                  checked={formData.weekdays.includes(day)}
                  onChange={(e) => {
                    const { value, checked } = e.target;
                    setFormData((prev) => ({
                      ...prev,
                      weekdays: checked
                        ? [...prev.weekdays, value]
                        : prev.weekdays.filter((d) => d !== value),
                    }));
                  }}
                />
                {day}
              </label>
            ))}
          </div>
        </fieldset>

        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            type="tel"
            id="mobile"
            name="mobile"
            className={`walkin-form ${formData.mobile ? 'has-value' : ''}`}
            value={formData.mobile}
            onChange={handleChange}
            pattern="[0-9]{10}"
            onInput={(e) => e.target.value = e.target.value.replace(/\D/g, '')}
            placeholder="Enter 10-digit number"
            maxLength={10}
            required
          />
          {formData.mobile && (
            <label htmlFor="mobile">Mobile Number*</label>
          )}
        </div>

        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <input
            type="text"
            id="name"
            name="name"
            className={`walkin-form ${formData.name ? 'has-value' : ''}`}
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter name"
            required
          />
          {formData.name && (
            <label htmlFor="name">Name*</label>
          )}
        </div>

        <div className="floating-select-form" style={{ width: '98%', position: 'relative' }}>
          <textarea
            id="remark"
            name="remark"
            className={`walkin-form-comments ${formData.remark ? 'has-value' : ''}`}
            value={formData.remark}
            onChange={handleChange}
            placeholder="Enter remarks"
            required
            rows="4"
          ></textarea>
          {formData.remark && (
            <label htmlFor="remark">Remark</label>
          )}
        </div>

        <div className="form-action">
          <button type="submit" className="submit-button">
            Submit
          </button>
        </div>
      </form>
      {showConflictModal && <ConflictModal />}
    </div>
  );
};

export default CourtBulkBooking;
